exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-819821da]::-webkit-inner-spin-button,input[data-v-819821da]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-819821da]{-moz-appearance:textfield}.tanpawrap[data-v-819821da]{white-space:nowrap}", ""]);

// exports
